import styled from 'styled-components';
import { theme, prop } from 'styled-tools';

import Cta from './Cta';

const CtaArrow = styled(Cta).attrs((props) => ({
  size: props.size ? props.size : '0.75em',
}))`
  position: relative;
  padding: 0.25em 0.5em 0.25em 0.5em;
  font-size: 17px;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 0px;
    width: 0px;
    margin-right: calc(-${prop('size')} + 1px);
    border-top: ${prop('size')} solid ${theme('colors.orange')};
    border-right: ${prop('size')} solid transparent;
  }
`;

export default CtaArrow;
